<template>
  <div class="con-list f-clearfix">
    <div v-if="noData == true" class="no-data" style="margin-top: 150px">
      <h2>暂无相关内容</h2>
    </div>
    <ul class="con-news f-clearfix">
      <li v-for="(item, index) in tableList" :key="index">
        <div
          class="item-img"
          @click="toDetail(item)"
          v-if="item.cover"
          style="cursor: pointer"
        >
          <img v-img="imgUrl + item.cover" alt />
        </div>
        <div class="item-content" :style="item.cover ? '' : 'width:980px'">
          <div class="item-newsTitle" :title="item.title">
            <h3 @click="toDetail(item)">{{ item.title }}</h3>
            <p v-if="item.categoryName != '' && item.categoryName != null">
              <span>{{ item.categoryName }}</span>
            </p>
            <div class="item-details" v-html="item.summary"></div>
          </div>
          <div class="item-datas">
            <span class="item-btn" @click="toDetail(item)">查看详情 &gt;</span>
            <span class="item-edu">{{ item.createdDt }}</span>
          </div>
        </div>
      </li>
    </ul>
    <div class="m-pagination-wrapper">
      <el-pagination
        class="m-pagination"
        @size-change="handleSizeChange"
        @current-change="newsPage"
        :page-size="newspageList.pageSize"
        :hide-on-single-page="true"
        :current-page.sync="newspageList.pageNo"
        :total="newspageList.total"
        layout=" prev, pager, next"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableList: [],
      imgUrl: this.$setting.fdsDomain,
      noData: false,
      newspageList: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      this.newspageList.pageSize = val;
      this.getList();
    },
    newsPage(val) {
      this.newspageList.pageNo = val;
      this.getList();
    },
    toDetail(val) {
      window.open(`/news/newsDetail?id=${val.id}`);
    },
    getList() {
      this.noData = false;
      let par = {
        currentPage: this.newspageList.pageNo,
        pageSize: this.newspageList.pageSize,
      };
      this.$http
        .get("api/web/article/pageList", { params: par })
        .then((res) => {
          this.tableList = res.data.records;
          this.newspageList.total = res.data.total;
          this.newspageList.pageNo = res.data.current;
          this.newspageList.pageSize = res.data.size;
          if (res.data.records == "") {
            this.noData = true;
          }
        })
        .catch((msg) => {
          console.log(msg);
        });
    },
  },
};
</script>
<style lang="scss">
.item-newsTitle {
  p {
    padding: 4px 0;
    span {
      background: #f1f2f3;
      color: #777;
      font-size: 12px;
      display: inline-block;
      padding: 4px 8px;
      border-radius: 4px;
    }
  }
}
</style>


